/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Clear_FiltersInputs */

const en_us2_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const pt_br2_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar filtros`)
};

const es_419_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar filtros`)
};

const pt_pt2_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar filtros`)
};

const fr_fr2_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les filtres`)
};

const de_de2_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter löschen`)
};

const it_it2_exercise_clear_filters = /** @type {(inputs: Exercise_Clear_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella filtri`)
};

/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Exercise_Clear_FiltersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_clear_filters = /** @type {((inputs?: Exercise_Clear_FiltersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Clear_FiltersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_clear_filters(inputs)
	if (locale === "es-419") return es_419_exercise_clear_filters(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_clear_filters(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_clear_filters(inputs)
	if (locale === "de-DE") return de_de2_exercise_clear_filters(inputs)
	if (locale === "it-IT") return it_it2_exercise_clear_filters(inputs)
	return en_us2_exercise_clear_filters(inputs)
});
export { exercise_clear_filters as "exercise.clear_filters" }